import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { pxToRem } from "../utilities/converters"

const VSpacer = styled.div`
  width: 100%;
  height: ${props => props.height ? pxToRem(props.height) : 0}rem;
`

export { VSpacer }